import React from "react";
import "../../layouts/Styles.css";
import { connect } from "react-redux";
import { mapReportSummary } from "../../internals/managers/ReportsManager";
import { formatPrice } from "../../internals/managers/PaymentManager";

const Summary = (props: any) => {
  const { dayReportSummary, selectedShop } = props;
  const mapSummaryList = mapReportSummary(dayReportSummary);
  const currency = selectedShop?.currency;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {mapSummaryList.map((summary: any, index: number) => {
        const isPositive = summary.growth >= 0;

        return (
          <div
            key={index}
            className="bg-surface rounded-card border border-borderc p-5 shadow-card flex flex-col gap-3.5"
          >
            {/* Caps label + delta pill */}
            <div className="flex items-center justify-between">
              <p className="nl-caps">{summary.name}</p>
              <span
                className={`flex items-center gap-1 text-[11.5px] font-semibold px-2 py-[3px] rounded-full ${
                  isPositive ? "bg-pos-soft text-pos" : "bg-neg-soft text-neg"
                }`}
              >
                {summary.growth > 0 ? `+${summary.growth}` : summary.growth}%
              </span>
            </div>

            {/* Value — JetBrains Mono per the design */}
            <span className="font-mono text-[26px] font-semibold text-text1 leading-none">
              {summary.type === "CUSTOMERS"
                ? summary.totalCount
                : formatPrice(summary.totalPrice, currency)}
            </span>

            {/* Sub line */}
            {summary.type !== "CUSTOMERS" ? (
              <p className="text-xs text-text3">
                {summary.text}:{" "}
                <span className="font-semibold text-text1">
                  {summary.totalCount}
                </span>
              </p>
            ) : (
              <p className="text-xs text-text3">Unique customers today</p>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default connect(
  (state: any) => ({
    selectedShop: state.dashboard.get("selectedShop"),
    dayReportSummary: state.dashboard.get("dayReportSummary"),
  }),
  () => ({})
)(Summary);
